import { render, staticRenderFns } from "./WithRubleIcon.vue?vue&type=template&id=9fce942c"
import script from "./WithRubleIcon.vue?vue&type=script&lang=js"
export * from "./WithRubleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports